import { useMemo } from 'react';

export default function useUrlQueryParams() {
    const searchParams = useMemo(() => {
        const search = new URLSearchParams(window.location.search);
        return new URLSearchParams(search);
    }, []);
    return searchParams;
}
